// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attached-photo-row[data-v-6c72fa9d]{display:flex;flex-wrap:wrap;margin:0 -5px -7px}.attached-photo-row__el[data-v-6c72fa9d]{display:flex;flex-direction:column;align-items:center;justify-content:center;width:70px;height:70px;margin:0 5px 7px;overflow:hidden;border-radius:3px}.attached-photo-row__photo[data-v-6c72fa9d]{display:block;max-width:100%;max-height:100%;cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
